import { defineMessages } from 'react-intl';

export default defineMessages({
    illnessLossCause: {
        id: 'fnol.adac.incident-type-page.Illness',
        defaultMessage: 'Illness'
    },
    howCanHelp: {
        id: 'fnol.adac.incident-type-page.How can we help?',
        defaultMessage: 'How can we help?'
    },
    illnessDescription: {
        id: 'fnol.adac.incident-type-page.Illness description',
        defaultMessage: 'Describe your illness'
    },
    accidentLossCause: {
        id: 'fnol.adac.incident-type-page.Accident',
        defaultMessage: 'Accident'
    },
    accidentDescription: {
        id: 'fnol.adac.incident-type-page.Accident description',
        defaultMessage: 'Describe your accident'
    },
    deathLossCause: {
        id: 'fnol.adac.incident-type-page.Death',
        defaultMessage: 'Death'
    }
});
